import { render } from "./PartnerPersonalData.vue?vue&type=template&id=3124edbb&scoped=true"
import script from "./PartnerPersonalData.vue?vue&type=script&lang=js"
export * from "./PartnerPersonalData.vue?vue&type=script&lang=js"

import "./PartnerPersonalData.vue?vue&type=style&index=0&id=3124edbb&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3124edbb"]])

export default __exports__